module.exports = __webpack_public_path__ + "img/rang3.a36a8b6e.png";